<template>
  <div>

    <el-row>
      <el-col :span="6">
        <span class="dash-value dash-num-blue" style="margin-top: 20px">{{totalCount}}</span>&nbsp;
        <span class="dash-title">{{$t('listUser.user')}}</span>&nbsp;
      </el-col>
      <el-col :span="18">
        <div class="searchBar">
          <slot><el-button type="primary" size="small" icon="el-icon-plus" @click="addUser">{{$t('listUser.add')}}</el-button></slot>
        </div>
      </el-col>
    </el-row>

    
    <el-table :data="items" style="width: 100%;padding: 10px 10px 10px 10px;">
      <el-table-column prop="contactor" :label="$t('listUser.name')"></el-table-column>
      <el-table-column prop="role" :label="$t('listUser.role')">
        <template slot-scope="scope">
          <span v-if="scope.row.role === 'A'">{{$t('addUser.A')}}</span>
          <span v-if="scope.row.role === 'B'">{{$t('addUser.B')}}</span>
          <span v-if="scope.row.role === 'C'">{{$t('addUser.C')}}</span>
          <span v-if="scope.row.role === 'T'">{{$t('addUser.T')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="groupName" :label="$t('listUser.group')"></el-table-column>
      <el-table-column prop="systemmail" :label="$t('addUser.systemmail')">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.systemmail === 1"></i>
        </template>
      </el-table-column>
      <el-table-column prop="billmail" :label="$t('addUser.billmail')">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.billmail === 1"></i>
        </template>
      </el-table-column>
      <el-table-column :label="$t('listUser.process')">
        <template slot-scope="scope">
          <el-button
            size="mini" type="primary" @click="update(scope.row.userID)" plain>{{$t('listUser.edit')}}</el-button>
          <el-button
            size="mini"
            type="danger" @click="confirmDelete(scope.row.userID)" plain>{{$t('listUser.remove')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    
  </div>
</template>

<script>
import { listUser,deleteUser} from "@/api/admin";
import { mapState } from "vuex";
import { ROUTER_PATH } from "@/constants/common.js";

const defaultSearchParams = {
  pageIndex: 1,
  pageSize: 10
};
export default {
  name: "ListUser",
  data: () => {
    return {
      searchParams: { ...defaultSearchParams },
      totalCount: 0,
      items: []
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  methods: {
    refreshData() {
      listUser({
        companyID: this.accountInfo.companyID,
        ...this.searchParams
      }).then(response => {
        this.totalCount = response.data.totalCount;
        this.items = response.data.items;
      });
    },
    handleCurrentChange(val) {
      this.searchParams = { ...this.searchParams, pageIndex: val };
      this.refreshData();
    },
    addUser(){
      this.$router.push(ROUTER_PATH.ADD_USER);
    },
    update(uid){
      this.$router.push({path:ROUTER_PATH.UPDATE_USER, query:{id:uid}});
    },
    confirmDelete(uid) {
        this.$confirm(this.$t('listUser.confirm'), this.$t('common.popup'), {
          confirmButtonText: this.$t('common.ok'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          deleteUser({
            userID: this.accountInfo.userID,
            targetUserID: uid
          }).then(response => {
            this.$message({
              type: 'success',
              message: response.message
            });
            this.refreshData();
          });
          
        }).catch(() => {
                  
        });
      }
  }
};
</script>
<style>
  .searchBar {
    margin: 0px 0px 10px 0px;
    /*padding: 10px 10px ;*/
    /*background-color: #f7f7f7;*/
    text-align: right;
  }
  </style>
